import React, { useState } from "react";
import styled from "styled-components";

export default function FormSelect({
  name,
  onChange,
  placeholder,
  defaultValue,
  label,
  options,
  optionLabel,
  optionValue,
  padding = "20px 15px",
  width = "100%",
  disabled,
  value,
}) {
  const [readOnly, setReadOnly] = useState(true);

  return (
    <>
      <Label htmlFor={name}>{label}</Label>
      <AppInputStyle
        style={{
          border: `1px solid ${disabled ? "#D0D5DD" : "#28282898"}`,
          width: width,
        }}
      >
        <div>
          <select
            readOnly={readOnly}
            onFocus={() => setReadOnly(false)}
            onBlur={() => setReadOnly(true)}
            autocomplete="off"
            name={name}
            onChange={onChange}
            required
            defaultValue={defaultValue}
            style={{ padding: padding }}
            disabled={disabled}
          >
            <option disabled selected>
              {placeholder}
            </option>
            {options?.map((opt) => {
              return (
                <option
                  selected={value === opt[optionValue]}
                  value={opt[optionValue]}
                >
                  {opt[optionLabel]}
                </option>
              );
            })}
          </select>
        </div>
        <svg
          style={{
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            right: "10px",
            pointerEvents: "none",
            opacity: disabled && "0.4",
          }}
          width="13"
          height="7"
          viewBox="0 0 13 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.995471 2.60642L5.32387 6.55416C5.97563 7.14861 7.02849 7.14861 7.68025 6.55416L12.0086 2.60642C13.0615 1.64616 12.3095 0 10.8221 0H2.16531C0.677944 0 -0.0573817 1.64616 0.995471 2.60642Z"
            fill="#212121"
          />
        </svg>
      </AppInputStyle>
    </>
  );
}

const Label = styled.label`
  font-size: 16px;
  font-weight: 500;
`;
const AppInputStyle = styled.div`
  outline: none;
  border-radius: 6px;
  background-color: white;
  padding: 0;
  margin-bottom: 20px;
  border: 1px solid #28282898;
  margin-top: 10px;
  position: relative;
  select {
    width: 100%;
    height: 100%;
    appearance: none;
    border-radius: 6px;
    outline: none;
    border: none;
    background: none;
    font-size: 16px;
  }
  input::placeholder {
    color: #ababab;
  }
`;
